import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";
import {UtilsService} from "../../js/utils-service";
import {ObjectService} from "../../js/object-service";
import {FormField} from "../form-field/form-field";

export class FormFieldCustomObject extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.$input = null;
        this.$info = null;
        this.$value = null;
        this.$modal = null;
        this.$modalBody = null;
        this.$modalTitle = null;
    }

    getCopySeed(){
        const seed = [this.$root.data("controller")];
        if(this.$root.data("seed")){
            seed.push(this.$root.data("seed"));
        }
        return JSON.stringify(seed);
    }

    copyValue(itemIndex){
        let v = this.$root.formFieldVal();
        if(itemIndex!==undefined){
            v = v[itemIndex];
        }
        if(v){
            const key = this.getCopySeed();
            GvfService.endpoint(
                this.$root.data("controller")+"/parse-clipboard-copy-value",
                {fieldData:this.$root.data(),value:v}
            ).then(
                (resp)=>{
                    localStorage[key] = JSON.stringify(resp.value);
                }
            );
        }
    }

    setValue(value,noEvent,noReloadInfo){
        if($.isPlainObject(value) || $.isArray(value)){
            this.$value.val(JSON.stringify(value));
        }else if(value && (value.indexOf("[")==0 || value.indexOf("{")==0)){
            this.$value.val(value);
            value = JSON.parse(value);
        }else{
            this.$info.html("");
            this.$value.val("");
            value = null;
        }
        this.$root.toggleClass("has-value",!!this.$value.val());
        this.$modal.modal("hide");
        if(!noReloadInfo){
            this.$info.addClass("is-loading");
            GvfService.endpoint(
                this.$root.data("controller")+"/render-custom-object-info",
                {value:value,fieldData: this.$root.data()}
            ).then(
                (resp) => {
                    this.$info.html(resp.html);
                    GvfUiService.init(this.$info);
                }
            ).finally(()=>{
                this.$info.removeClass("is-loading");
            });
        }else{ //no reload info: need to update data attribute for each item
            const $items = this.$info.find(":not(.js-custom-object-info__item) .js-custom-object-info__item");
            if($.isPlainObject(value)){
                $items.data("data",value);
            }else if($.isArray(value) && value && $items.length==value.length){
                for(let i = 0; i<value.length; i++){
                    $items.eq(i).data("data",value[i]);
                }
            }
        }
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    addValue(value,noEvent,replaceIndex){
        if($.isNumeric(replaceIndex)){ //replaceIndex must be a string path
            replaceIndex = "["+replaceIndex+"]";
        }

        if(this.$root.data("multiple")){
            let values = [];
            if(this.$value.val()){
                values = JSON.parse(this.$value.val());
            }
            if(replaceIndex!==undefined && /^[0-9a-zA-Z\[\].]+\+?$/i.test(replaceIndex)){
                if(replaceIndex.indexOf("+")> -1){ //inserting at a position
                    if(/\[[0-9]+]\+$/i.test(replaceIndex)){ //ensure expression ends with [N]+
                        const lastIndex = replaceIndex.lastIndexOf("[");
                        const replaceListPath = replaceIndex.substring(0,lastIndex);
                        const replaceListIndex = parseInt(replaceIndex.substring(lastIndex+1,replaceIndex.length-2));
                        eval("values"+replaceListPath+".splice("+replaceListIndex+",0,value)");
                    }
                }else{
                    eval("values"+replaceIndex+"=value");
                }
            }else{
                values.push(value);
            }
            this.setValue(values,noEvent);
        }else{
            this.setValue(value,noEvent);
        }
    }

    addValueRef(refId){
        this.addValue({"ref": refId});
    }

    removeItem(index){
        if(this.$root.data("multiple")){
            const items = this.$root.formFieldVal();
            items.splice(index,1);
            this.setValue(items,false);
        }else{
            this.setValue("");
        }
    }

    openModal(data,editPosition){
        if($.isNumeric(editPosition)){ //convert editPosition to a valid path
            editPosition = "["+editPosition+"]";
        }else{
            this.$modal.addClass("is-initial-load");
        }

        this.$modal.addClass("is-loading");
        this.$modalBody.html("");
        this.$modal.modal("show");
        const fieldData = this.$root.data();
        fieldData.editPosition = editPosition;
        fieldData.form = this.$root.closest(".js-form").getValues();
        GvfService.endpoint(
            this.$root.data("controller")+"/render-custom-object-edition-form",
            {data:data??null,fieldData:fieldData}
        ).then(
            (resp) => {
                this.$modalTitle.html(resp.title);
                this.$modalBody.html(resp.html);
                this.$modalBody.find(".js-custom-object-edit__form").submit(
                    (ev) => {
                        ev.preventDefault();
                        const $form = $(ev.currentTarget);
                        $form.checkRestrictions().then(
                            (isOk)=>{
                                if(isOk){
                                    const v = $form.getValues();
                                    GvfService.endpoint(
                                        this.$root.data("controller")+"/submit-edition-form",
                                        {formData: v,fieldData: this.$root.data()}
                                    ).then(
                                        (resp) => {
                                            if(this.$root.data("multiple")){
                                                this.addValue(resp.data,false,editPosition);
                                            }else{
                                                this.setValue(resp.data);
                                            }
                                        }
                                    ).catch(
                                        (resp)=>{
                                            if(resp.hasOwnProperty("responseJSON") && resp.responseJSON.validation){
                                                $form.applyValidationResponse(resp.responseJSON.validation);
                                            }else{
                                                UtilsService.alertEndpointResponse(resp);
                                            }
                                        }
                                    );
                                }
                            }
                        );
                    }
                );
                GvfUiService.init(this.$modalBody);
            }
        ).catch(UtilsService.alertEndpointResponse).finally(
            ()=>{
                this.$modal.removeClass("is-loading is-initial-load");
            }
        );
    }

    getVal(){
        const val = this.$value.val();
        if(val){
            try{
                return JSON.parse(this.$value.val());
            }catch(e){
                return "";
            }
        }else{
            return "";
        }
    }

    setVal(val,noEvent){
        this.setValue(val,noEvent);
    }

    ready(){
        super.ready();
        this.$info = this.findMember("info");
        this.$input = this.findMember("input");
        this.$value = this.findMember("value");
        this.$modal = this.findMember("modal").clone().appendTo($("body"));
        this.$modalBody = this.$modal.find(this.scope+"__modal-body");
        this.$modalTitle = this.$modal.find(this.scope+"__modal-title");
        this.$modal.data("sourceField",this.$root);

        this.$root.data("openModal",this.openModal.bind(this));
        this.$root.data("addValue",this.addValue.bind(this));
        this.$root.data("setValue",this.setValue.bind(this));
        this.$root.data("removeItem",this.removeItem.bind(this));
        this.$root.data("copyValue",this.copyValue.bind(this));

        this.$modal.find(this.scope+"__save").click(
            (ev)=>{
                ev.preventDefault();
                this.$modalBody.find(".js-custom-object-edit__form").submit();
            }
        );

        this.findMember("empty").click(
            (ev) => {
                ev.preventDefault();
                this.setValue("");
            }
        );

        this.findMember("add").click(
            (ev) => {
                ev.preventDefault();
                this.openModal();
            }
        );

        this.findMember("copy").click(
            (ev) => {
                ev.preventDefault();
                this.copyValue();
            }
        );

        this.findMember("paste").click(
            (ev) => {
                ev.preventDefault();
                const key = this.getCopySeed();
                let val = JSON.parse(localStorage[key]);
                //conversion between multiple/single selectors or single items copied
                if(this.$root.data("multiple") && $.isPlainObject(val)){
                    this.addValue(val);
                }else{
                    if(!this.$root.data("multiple") && $.isArray(val)){
                        val = val[0];
                    }
                    this.setValue(val);
                }
            }
        );

        this.findMember("worker-load").click(
            (ev) => {
                ev.preventDefault();
                const service = new ObjectService("WorkerLibraryItem");
                service.selectModelItem(
                    {
                        fieldData: {"worker_group_id": this.$root.data("g")},
                        contentReadyCallback: ($modal) => {
                            $modal.on(
                                "workerItem:addRef",
                                (ev,id) => {
                                    $modal.modal("hide");
                                    this.addValueRef(id);
                                }
                            );
                            $modal.on(
                                "workerItem:addValue",
                                (ev,value) => {
                                    $modal.modal("hide");
                                    for(let i in value){
                                        this.addValue(value[i]);
                                    }
                                }
                            );
                        }
                    }
                ).then(
                    (id) => {
                        this.addValueRef(id);
                    }
                );
            }
        );

        this.findMember("worker-save").click(
            (ev)=>{
                ev.preventDefault();
                const service = new ObjectService("WorkerLibraryItem");
                service.openDetailModal(
                    {
                        editMode: true,
                        data: {"worker_group_id": this.$root.data("g"),"value": this.$root.formFieldVal()}
                    }
                );
            }
        );

        //initial load
        this.setValue(this.$value.val(),true);
    }
}


//extend jquery to get values
jQuery.fn.extend(
    {
        "openModal": function(data,editPosition){
            if(this.data("openModal")){
                return this.data("openModal")(data,editPosition);
            }
        },
        "addValue": function(value,noEvent,editPosition){
            if(this.data("addValue")){
                return this.data("addValue")(value,noEvent,editPosition);
            }
        },
        "setValue": function(value,noEvent,noReloadInfo){
            if(this.data("setValue")){
                return this.data("setValue")(value,noEvent,noReloadInfo);
            }
        },
        "copyValue": function(itemIndex){
            if(this.data("copyValue")){
                return this.data("copyValue")(itemIndex);
            }
        },
        "removeItem": function(index){
            if(this.data("removeItem")){
                return this.data("removeItem")(index);
            }
        }
    }
);
